module.exports = __webpack_public_path__ + "static/thaw-forecasts-bg-f297d84717f55b47324b6b34e06242a4.png";